import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import FloorplansServerComponent from "./components/floorplans/floorplanListing/floorplansServerComponent";
import "./styles/style.scss";
import Sightmap from "./components/sightmap/sightmap";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/floor-plans" />} />
        <Route
          path="/floor-plans"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <FloorplansServerComponent typeListing={true} />
            </Suspense>
          }
        />
        <Route
          path="/floor-plans/:floorplanName/:floorplanId"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <FloorplansServerComponent typeListing={false} />
            </Suspense>
          }
        />
        <Route
          path="/sightmap"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <Sightmap />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/floor-plans" />} />
      </Routes>
    </Router>
  );
}

export default App;
